import axios from 'axios'

// Get data for the dashboard
const getData = async (iniDate, endDate, sellType) => {
  const { data } = await axios.get(`${process.env.VUE_APP_API}/dashboard/${iniDate}/${endDate}/${sellType}`)
  return data
}

export {
  getData
}
